import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, Teleport as _Teleport, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/icons/forward.png'
import _imports_1 from '../../assets/icons/add.png'


const _hoisted_1 = { class: "mt-4 px-4" }
const _hoisted_2 = { class: "action-row col-start-1 col-end-13 flex w-full items-center justify-end mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "mr-4",
  width: "20",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "mr-4",
  width: "20",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_5 = { class: "calendar-container w-full min-h-[90vh] max-h-[90vh] relative col-start-1 col-end-13 overflow-y-scroll" }

import type { ByEvent } from "@/types";
import type { EventCategory } from "@/types";

import { ref, reactive, onBeforeMount, computed } from "vue"

import { deleteData, updateData } from "../../mixins/modularFirebaseOperations"
import { modalClosed } from "../../mixins/visualFormatters"
import { mapEventCatsToColorSchemes, getAllEvents, useGetEmployeeBirthdays } from "../../mixins/calendarOperations"
import { useRoute } from "vue-router"
import { Qalendar } from "qalendar"
import { getRepaymentDates } from "../../mixins/calendarOperations"
import acMediumModal from "../reusable/teleports/acMediumModal.vue";
import addEvent from "../reusable/teleports/addEvent.vue";
import acLoader from "../reusable/acLoader.vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'accaCalendar',
  setup(__props) {


const store = useStore()
const userProfile = computed(() => store.state.user.userProfile)

const isLoadingEvents = ref(false)
const events = ref<ByEvent[]>([])
const editedEvent = ref<ByEvent | undefined>(undefined)
const eventCats = ref<EventCategory[]>([])
const isAddingEvent = ref(false)

const { birthdays, isLoadingBirthdays } = useGetEmployeeBirthdays()
const { repaymentDates, isLoadingRepaymentDates } = getRepaymentDates()

const newlyAddedEvents = ref<ByEvent[]>([])

// Use this at the start of the year to populate the days with special days.

/* const startOfYearPopulateDays = [

    // Official

  {
    "category": "Özel Gün ve Tatiller",
    "description": "",
    "isEditable": false,
    "time": { "start": "2025-01-01", "end": "2025-01-01" },
    "title": "Yılbaşı"
  },
  {
    "category": "Özel Gün ve Tatiller",
    "description": "",
    "isEditable": false,
    "time": { "start": "2025-04-23", "end": "2025-04-23" },
    "title": "23 Nisan Ulusal Egemenlik ve Çocuk Bayramı"
  },
  {
    "category": "Özel Gün ve Tatiller",
    "description": "",
    "isEditable": false,
    "time": { "start": "2025-05-01", "end": "2025-05-01" },
    "title": "1 Mayıs İşçi ve Emekçi Bayramı"
  },
  {
    "category": "Özel Gün ve Tatiller",
    "description": "",
    "isEditable": false,
    "time": { "start": "2025-05-19", "end": "2025-05-19" },
    "title": "19 Mayıs Atatürk'ü Anma, Gençlik ve Spor Bayramı"
  },
  {
    "category": "Özel Gün ve Tatiller",
    "description": "",
    "isEditable": false,
    "time": { "start": "2025-07-15", "end": "2025-07-15" },
    "title": "15 Temmuz Demokrasi ve Millî Birlik Günü"
  },
  {
    "category": "Özel Gün ve Tatiller",
    "description": "",
    "isEditable": false,
    "time": { "start": "2025-08-30", "end": "2025-08-30" },
    "title": "30 Ağustos Zafer Bayramı"
  },
  {
    "category": "Özel Gün ve Tatiller",
    "description": "",
    "isEditable": false,
    "time": { "start": "2025-10-29", "end": "2025-10-29" },
    "title": "29 Ekim Cumhuriyet Bayramı"
  },
  {
    "category": "Özel Gün ve Tatiller",
    "description": "",
    "isEditable": false,
    "time": { "start": "2025-11-10", "end": "2025-11-10" },
    "title": "10 Kasım Atatürk'ü Anma Günü"
  },

    // Religious -- these change every year.

  {
    "category": "Özel Gün ve Tatiller",
    "description": "Ramazan Bayramı Arifesi",
    "isEditable": false,
    "time": { "start": "2025-03-29", "end": "2025-03-29" },
    "title": "Ramazan Bayramı Arifesi"
  },
  {
    "category": "Özel Gün ve Tatiller",
    "description": "Ramazan Bayramı - 1. Gün",
    "isEditable": false,
    "time": { "start": "2025-03-30", "end": "2025-03-30" },
    "title": "Ramazan Bayramı"
  },
  {
    "category": "Özel Gün ve Tatiller",
    "description": "Ramazan Bayramı - 2. Gün",
    "isEditable": false,
    "time": { "start": "2025-03-31", "end": "2025-03-31" },
    "title": "Ramazan Bayramı"
  },


  {
    "category": "Özel Gün ve Tatiller",
    "description": "Ramazan Bayramı - 3. Gün",
    "isEditable": false,
    "time": { "start": "2025-04-01", "end": "2025-04-01" },
    "title": "Ramazan Bayramı"
  },
  {
    "category": "Özel Gün ve Tatiller",
    "description": "Kurban Bayramı Arifesi",
    "isEditable": false,
    "time": { "start": "2025-06-06", "end": "2025-06-06" },
    "title": "Kurban Bayramı Arifesi"
  },
  {
    "category": "Özel Gün ve Tatiller",
    "description": "Kurban Bayramı - 1. Gün",
    "isEditable": false,
    "time": { "start": "2025-06-07", "end": "2025-06-07" },
    "title": "Kurban Bayramı"
  },
  {
    "category": "Özel Gün ve Tatiller",
    "description": "Kurban Bayramı - 2. Gün",
    "isEditable": false,
    "time": { "start": "2025-06-08", "end": "2025-06-08" },
    "title": "Kurban Bayramı"
  },
  {
    "category": "Özel Gün ve Tatiller",
    "description": "Kurban Bayramı - 3. Gün",
    "isEditable": false,
    "time": { "start": "2025-06-09", "end": "2025-06-09" },
    "title": "Kurban Bayramı"
  },
  {
    "category": "Özel Gün ve Tatiller",
    "description": "Kurban Bayramı - 4. Gün",
    "isEditable": false,
    "time": { "start": "2025-06-10", "end": "2025-06-10" },
    "title": "Kurban Bayramı"
  }
] */

/* 

Import postData before you comment this back in.

const populateCalendarAtStartofYear = async () => {
    console.log("Starting mass write")
    for (const day of startOfYearPopulateDays) {
        const id = await postData(day, "events")
        console.log("Written: ", id, day.title)
    }
    console.log("Mass write completed")
}
 */
const displayedEvents = computed(() => {
    if(userProfile.value.department === "finance" || userProfile.value.department === "executive")  {
        return [...events.value, ...newlyAddedEvents.value, ...birthdays.value, ...repaymentDates.value]
    } else {
        return [...events.value, ...newlyAddedEvents.value, ...birthdays.value]
    }
})

const handleEventAdded = function (newEvent: ByEvent) {
    newlyAddedEvents.value.push({
        id: newEvent.id,
        title: newEvent.title,
        description: newEvent.description,
        colorScheme: newEvent.category,
        time: newEvent.time,
        isEditable: true,
    })
    isAddingEvent.value = false
    modalClosed()
}

const handleEditEventInitiated = (e: string) => {
    const index = findEditedEventIndex(e)
    if (index) {
        if (index.existing) {
            editedEvent.value = events.value[index.index]
        } else {
            editedEvent.value = newlyAddedEvents.value[index.index]
        }
    }
}

const handleUpdateEventCompleted = (updatedEvent: ByEvent) => {
    const eventIndex = findEditedEventIndex(updatedEvent.id)

    if (eventIndex) {
        if (eventIndex.existing) {
            events.value[eventIndex.index] = updatedEvent
        } else {
            newlyAddedEvents.value[eventIndex.index] = updatedEvent
        }
    }

    editedEvent.value = undefined
    modalClosed()

}

const handleDeleteEvent = async (e: string) => {
    await deleteData("events", e)
    events.value = events.value.filter((event) => event.id !== e)
    
}

const handleDragEvent = async (e) => {
    await updateData("events", e.id, e)
}

const findEditedEventIndex = (e: string) => {
    let index = events.value.findIndex((event) => event.id === e)
    if (index !== -1) {
        return {
            index,
            existing: true,
        }
    } else {
        index = newlyAddedEvents.value.findIndex((event) => event.id === e)
        if (index !== -1) {
            return {
                index,
                existing: false,
            }
        } else {
            return undefined
        }
    }
}

const calendarConfig = reactive({
    week: {
        startsOn: "monday",
        scrollToHour: 6,
    },
    locale: "tr-TR",
    style: {
        fontFamily: "sans-serif",
        colorSchemes: {},
    },
    month: {
        // Hide leading and trailing dates in the month view (defaults to true when not set)
        showTrailingAndLeadingDates: false,
    },
    defaultMode: "month",
    showCurrentTime: true,
    isSilent: true,
})

const route = useRoute()
const selectedDate = route.query.day ? new Date(route.query.day) : new Date()

onBeforeMount( async () => {
    isLoadingEvents.value = true
    await mapEventCatsToColorSchemes(eventCats, calendarConfig, isLoadingEvents)
    await getAllEvents(events.value, isLoadingEvents)

})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/calendar/event-categories",
        class: "ac-add-button mr-6"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Etkinlik Kategorilerini Düzenle ")
        ]),
        _: 1
      }),
      _createElementVNode("button", {
        type: "button",
        class: "ac-add-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isAddingEvent.value = true))
      }, [
        _hoisted_4,
        _createTextVNode(" Yeni Etkinlik Ekle ")
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (!isLoadingEvents.value && !_unref(isLoadingBirthdays) && !_unref(isLoadingRepaymentDates))
        ? (_openBlock(), _createBlock(_unref(Qalendar), {
            key: 0,
            class: "min-h-[85vh]",
            selectedDate: _unref(selectedDate),
            events: displayedEvents.value,
            config: calendarConfig,
            onEditEvent: _cache[1] || (_cache[1] = ($event: any) => (handleEditEventInitiated($event))),
            onDeleteEvent: _cache[2] || (_cache[2] = ($event: any) => (handleDeleteEvent($event))),
            onEventWasDragged: _cache[3] || (_cache[3] = ($event: any) => (handleDragEvent($event))),
            onEventWasResized: _cache[4] || (_cache[4] = ($event: any) => (handleDragEvent($event)))
          }, null, 8, ["selectedDate", "events", "config"]))
        : (_openBlock(), _createBlock(acLoader, {
            key: 1,
            class: "!top-[50%] h-full left-[50%] !absolute"
          }))
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
      _createVNode(_Transition, {
        appear: "",
        type: "animation",
        "enter-active-class": "animate__animated animate__fadeIn animate__fast",
        "leave-active-class": "animate__animated animate__fadeOut animate__faster"
      }, {
        default: _withCtx(() => [
          (isAddingEvent.value || editedEvent.value)
            ? (_openBlock(), _createBlock(acMediumModal, {
                key: 0,
                class: "lg:!top-44 overflow-y-scroll",
                onModalClosed: _cache[7] || (_cache[7] = ($event: any) => {isAddingEvent.value = false; editedEvent.value = undefined}),
                height: "85vh",
                width: "70vw",
                title: "Yeni Ekle"
              }, {
                default: _withCtx(() => [
                  _createVNode(addEvent, {
                    "edited-event": editedEvent.value,
                    onEventAdded: _cache[5] || (_cache[5] = ($event: any) => (handleEventAdded($event))),
                    onEventUpdated: _cache[6] || (_cache[6] = ($event: any) => (handleUpdateEventCompleted($event)))
                  }, null, 8, ["edited-event"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}
}

})